import React from 'react';

import RichTextConverter from '../../components/Common/RichText/RichTextConverter';
import { addTrailingSlash } from '../../tools/textTools';
import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import SmartLink from '../Common/SmartLink';
import * as styles from './Card.module.scss';

export default function Card({ image, flipImage, type, readingTime, title, description, url, ctaLabel, className }) {
  const slug = addTrailingSlash(url);
  return (
    <div
      data-analytics-component="card"
      data-analytics-id={title}
      className={[styles.card, className, image ? styles.whiteBackground : ''].join(' ')}
    >
      {image && !flipImage && (
        <SmartLink to={slug} className={styles.image}>
          <ContentfulImage imageFragment={image} />
        </SmartLink>
      )}
      {(type || readingTime) && (
        <div className={styles.type}>
          {type && (
            <span>
              {type}
              {readingTime && ' • '}
            </span>
          )}
          {readingTime && <span className={styles.readingTime}>{readingTime}</span>}
        </div>
      )}
      <SmartLink to={slug} className={styles.title}>
        {title}
      </SmartLink>
      <div className={styles.description}>
        {description?.raw && <RichTextConverter copy={description} />}
        {!description?.raw && <p>{description}</p>}
      </div>
      {slug && <ArrowLink label={ctaLabel || 'View more'} url={slug} className={styles.cta} hoverAnimation />}
      {image && flipImage && (
        <SmartLink to={slug} className={styles.image}>
          <ContentfulImage imageFragment={image} />
        </SmartLink>
      )}
    </div>
  );
}
